import { css, Interpolation, Theme } from '@emotion/react'

export const content = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 30px 0;
`

export const list: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
`

export const title: Interpolation<Theme> = (theme) => css`
  font-weight: 700;
  line-height: 28px;
  color: ${theme.typographyColors.typographyTwo};
`

export const username: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyTwo};
`

export const datetime: Interpolation<Theme> = (theme) => css`
  color: ${theme.colors.blue};
`

export const separator: Interpolation<Theme> = (theme) => css`
  width: 100%;
  height: 1px;
  background: ${theme.backgrounds.backgroundOne};
`
